import './clientConsumptions.scss'
import { Box, Grid, Paper, Typography } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useFindConsumptionsByTenantQuery, useFindContractsQuery } from '../../../features/client/clientSlice'
import DatatableClientServicesConsumptions from '../../../components/common/datatable/DatatableClientServicesConsumptions'
import DatatableClients from '../../../components/common/datatable/DatatableClients'
import MyDatePicker from '../../../components/utilities/MyDatePicker'
import dayjs from 'dayjs'
import { useState } from 'react'

const ClientConsumptions = () => {
  const queryState = useSelector((state) => state.clientConsumptions.filters)
  const initialFromDate = dayjs().startOf('month')
  const initialEndDate = dayjs().endOf('month')
  const [fromDate, setFromDate] = useState(queryState.fromDate ?? initialFromDate)
  const [endDate, setEndDate] = useState(queryState.endDate ?? initialEndDate)
  const { t } = useTranslation(['common'])
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const { data: clients, isLoading, isFetching, refetch } = useFindContractsQuery()

  const {
    data: consumptions,
    isLoading: isConsumptionsLoading,
    isFetching: isConsumptionsFetching,
    refetchConsumptions,
  } = useFindConsumptionsByTenantQuery({
    ...queryState,
    fromDate: dayjs(fromDate).startOf('date').format('YYYY-MM-DDTHH:mm:ss'),
    toDate: dayjs(endDate).endOf('date').format('YYYY-MM-DDTHH:mm:ss'),
    tenant: searchParams.get('tenant'),
    groupBy: 'product,type,action,tenant',
    status: 'SUCCESS',
  })

  if (searchParams.get('tenant')) {
    return (
      <Box className="filter">
        <Box>
          <Box className="component-title">
            <Typography variant="h2">{t('common:consumptions')}</Typography>
          </Box>
          <Grid container spacing={2} direction="row" alignItems="center" marginBottom={1}>
            <Grid item xs={1}>
              <Typography variant="subtitle3">{t('common:initialDate')}:</Typography>
            </Grid>
            <Grid item>
              <MyDatePicker selectedDate={dayjs(fromDate)} setSelectedDate={(newValue) => setFromDate(newValue)} />
            </Grid>
          </Grid>
          <Grid container spacing={2} direction="row" alignItems="center">
            <Grid item xs={1}>
              <Typography variant="subtitle3">{t('common:endDate')}:</Typography>
            </Grid>
            <Grid item>
              <MyDatePicker selectedDate={dayjs(endDate)} setSelectedDate={(newValue) => setEndDate(newValue)} />
            </Grid>
          </Grid>
        </Box>
        <Paper elevation={0}>
          <DatatableClientServicesConsumptions
            consumptions={consumptions}
            isLoading={isConsumptionsLoading || isConsumptionsFetching}
            refetch={refetchConsumptions}
          />
        </Paper>
      </Box>
    )
  }

  return (
    <Box className="filter">
      <Box>
        <Box className="component-title">
          <Typography variant="h2">{t('common:consumptions')}</Typography>
        </Box>
      </Box>
      <Paper elevation={0}>
        <DatatableClients
          clients={clients}
          onClick={(row) => {
            navigate(`/admin/client-consumptions?tenant=${row.tenant}`)
          }}
          isLoading={isLoading || isFetching}
          refetch={refetch}
        />
      </Paper>
    </Box>
  )
}

export default ClientConsumptions
